export default __webpack_public_path__ + "static/media/title-icon.66ca86f3.svg";